import { LitElement, css, html } from 'lit';
import { msg, localized } from '@lit/localize';
import { customElement, property } from 'lit/decorators.js';
import { globalStyles } from '../global-styles.js';

@localized()
@customElement('pp-cashier-extra')
export class PpCashierExtra extends LitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: block;
      }

      .pp-cancel {
        text-align: var(--pp-checkout-return-position);
      }

      .pp-cancel a {
        color: var(--pp-checkout-theme-color);
      }

      @media only screen and (min-width: 0) and (max-width: 576px){
        .pp-cancel {
          padding: 0 12px;
        }
      }
    `
  ];

  @property({ type: String }) cancelUrl = '';

  @property({ type: String }) returnBtnText = '';

  get cancelText() {
    const defaultText = 'Cancel and return seller website';
    const text = this.returnBtnText || defaultText;
    
    return text === defaultText? msg('Cancel and return seller website'): text;
  }
  
  render() {
    return html`
      <div class="pp-cancel text-xs p-t-1 align-center">
        <a class="font-medium" href="${this.cancelUrl}">
          ${this.cancelText}
        </a>
      </div>
    `;
  }
}
